import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconVerified } from '@change-corgi/design-system-legacy/icons';

import type { PetitionDetails } from 'src/app/pages/petitionDetails/shared/types';

export function OrganizationLink({
	organization,
}: {
	organization: NonNullable<PetitionDetails['organization']>;
}): JSX.Element {
	const { translate } = useI18n();

	return (
		<Text variant="body" size="medium" fontWeight="bold" data-testid="petition-starter-organization" className="mb-1">
			{organization.name}
			{organization.verificationStatus === 'VERIFIED' ? (
				<Icon
					icon={iconVerified}
					color="secondary-green"
					size="s"
					role="img"
					aria-label={translate('fe.pages.organization.verified_label')}
					sx={{ display: 'inline-block' }}
				/>
			) : null}
		</Text>
	);
}
